<template>
    <transition name="fade">
      <div v-if="noticeContent" class="notice-popup-overlay" @click="closePopup">
        <div class="notice-popup" @click.stop>
          <div class="close-btn" @click="closePopup">×</div>
          <div class="notice-popup-content">
            <p>{{ noticeContent }}</p>
          </div>
          <div class="notice-popup-footer">
            <button class="confirm-btn" @click="confirmAction">{{ letter.confirm }}</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import { mapGetters, mapState } from "vuex";
  import { HIDE_NOTICE } from "../store/web/h5";
  export default {
    name: "NoticePopup",
    computed: {
        ...mapState({
            noticeContent: (state) => state.noticeContent,
        }),
      ...mapGetters(["letter"]),
    },
    created() {
        console.log(this.$store.state)
    },
    methods: {
      closePopup() {
        this.$store.commit(HIDE_NOTICE);
      },
      confirmAction() {
        this.$store.commit(HIDE_NOTICE);
        this.closePopup();
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .notice-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .notice-popup {
    position: relative;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    max-width: 400px;
    width: 90%;
    overflow: hidden;
    padding: 40px 0 0;
  }
  
  .close-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 24px;
    color: #999;
    cursor: pointer;
    line-height: 1;
    z-index: 1001;
    
    &:hover {
      color: #333;
    }
  }
  
  .notice-popup-content {
    padding: 40px 20px 20px;
    height: 260px;
    overflow-y: auto;
    text-align: center;
    
    p {
      margin: 0;
      font-size: 16px;
      color: #000000;
      line-height: 1.5;
      text-align: left;
      white-space: pre-wrap;
    }
  }
  
  .notice-popup-footer {
    padding: 20px;
    text-align: center;
    border-top: 1px solid #f0f0f0;
  }
  
  .confirm-btn {
    background-color: #d670e1;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 10px 30px;
    font-size: 16px;
    width: 100%;
    cursor: pointer;
  
  }
  </style>
  